import {SwapHoriz} from "@mui/icons-material";
import {Drawer, IconButton, Stack, TextField, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {addPlace, convertAnchoredDateLocaleTextToMillis, generateStringKeyFromMillis, PlaceModel, TripModel} from "../../firebase/index.js";
import {useInMemoryTrip} from "../../redux/InMemoryTripReducer.js";
import APXActionButtons from "../../reusables/APXActionButtons.jsx";
import APXCheckboxDependentOptionSelector from "../../reusables/APXCheckboxDependentOptionSelector.jsx";
import type {BSLProps} from "../../reusables/js/APXBottomSheetLayoutUtils.js";
import useBottomSheet from "../../reusables/js/APXBottomSheetLayoutUtils.js";
import TransportButtonGroup, {defaultTransportName} from "./TransportSelector.jsx";


export default function AddNewTransportBSL({uid, onClose, place}: BSLProps & { place: PlaceModel }) {
	  const [transportName, setTransportName] = useState(defaultTransportName);
	  const [from, setFrom] = useState("");
	  const [to, setTo] = useState("");
	  const [anchoredDateLocaleText, setAnchoredDateLocaleText] = useState(null);
	  const [note, setNote] = useState("");
	  
	  const [isChecked, setIsChecked] = useState(false);
	  
	  const [placeKey, setPlaceKey] = useState("");
	  useEffect(() => {
			 const p: PlaceModel = place;
			 if (/*TRUTHY->*/ !!p) {
					setPlaceKey(p.placeKey);
					setTransportName(p.transportName);
					const fromAndTo = p.name.split(" → ");
					setFrom(fromAndTo[0]);
					setTo(fromAndTo[1]);
					setAnchoredDateLocaleText(p.anchoredOnDate && new Date(p.anchoredOnDate).toLocaleDateString());
					setNote(p.note);
			 }
	  }, [place]);
	  
	  const inMemoryTrip: TripModel = useInMemoryTrip();
	  
	  const {isOpen, handleOpen, handleClose} = useBottomSheet({initialState: true, onClose});
	  
	  const handleCancel = () => {
			 onClose();
	  };
	  
	  const handleAdd = () => {
			 if (/*FALSY->*/ !!!uid) {
					alert("Please login to add a trip");
					return;
			 }
			 if (from.trim() === "" || to.trim() === "") {
					alert("Please fill in all required fields");
					return;
			 }
			 if (Object.keys(inMemoryTrip.tripDates).length > 0 && isChecked && anchoredDateLocaleText === null) {
					alert("Anchored date cannot be empty");
					return;
			 }
			 
			 const key = placeKey || generateStringKeyFromMillis();
			 
			 const anchoredOnDate = convertAnchoredDateLocaleTextToMillis(anchoredDateLocaleText);
			 
			 const transportPlace = PlaceModel.asTransport(key, `${from.trim()} → ${to.trim()}`, transportName.trim(), note.trim(), anchoredOnDate);
			 
			 addPlace(uid, inMemoryTrip.itineraryKey, anchoredOnDate, key, transportPlace);
			 
			 handleCancel();
	  };
	  
	  return (
				 <Drawer anchor="bottom" open={isOpen} onClose={handleClose} variant="temporary">
						<Stack spacing={2} p={2}>
							  <Stack justifyContent={"center"} alignItems={"center"}>
									 <TransportButtonGroup value={transportName} onChange={(name) => setTransportName(name)}/>
							  </Stack>
							  <Stack direction={{xs: "column", sm: "row"}} spacing={1}>
									 <TextField
												required
												fullWidth
												variant="outlined"
												label="From"
												value={from}
												onChange={(e) => setFrom(e.target.value)}
									 />
									 <IconButton onClick={() => {
											const temp = from;
											setFrom(to);
											setTo(temp);
									 }}>
											<SwapHoriz sx={{width: 36, height: 36}}/>
									 </IconButton>
									 <TextField
												required
												fullWidth
												variant="outlined"
												label="To"
												value={to}
												onChange={(e) => setTo(e.target.value)}
									 />
							  </Stack>
							  {
									 /*FALSY->*/ !!!place ?
										 <APXCheckboxDependentOptionSelector
													disabled={Object.keys(inMemoryTrip.tripDates).length === 0}
													checkboxLabel={"Anchor"}
													options={Object.values(inMemoryTrip.tripDates)}
													textFieldLabel={"to a specific date"}
													value={anchoredDateLocaleText}
													onOptionSelected={(newValue) => {
														  setAnchoredDateLocaleText(newValue);
													}}
													checked={isChecked}
													onCheckedChange={(checked: boolean) => setIsChecked(checked)}
										 />
										 :
										 anchoredDateLocaleText && <Typography align={"center"} sx={{mt: 2}}>Anchored on: {anchoredDateLocaleText}</Typography>
							  }
							  <TextField
										 fullWidth
										 variant="outlined"
										 label="Note"
										 multiline
										 rows={1}
										 value={note}
										 onChange={(e) => setNote(e.target.value)}
							  />
							  <APXActionButtons onCancel={handleCancel} onAdd={handleAdd}/>
						</Stack>
				 </Drawer>
	  );
}